import { render, staticRenderFns } from "./WithdrawalSetting.vue?vue&type=template&id=44e13a8a&scoped=true&"
import script from "./WithdrawalSetting.vue?vue&type=script&lang=js&"
export * from "./WithdrawalSetting.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalSetting.vue?vue&type=style&index=0&id=44e13a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e13a8a",
  null
  
)

export default component.exports